import { render, staticRenderFns } from "./QuartzManage.vue?vue&type=template&id=2c1114f8&scoped=true&"
import script from "./QuartzManage.vue?vue&type=script&lang=js&"
export * from "./QuartzManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1114f8",
  null
  
)

export default component.exports